<template>
  <div id="posabit-app" class="posabit-widget">
    <app-header v-if="!loading && loaded"></app-header>
    <router-view v-if="!loading && loaded"></router-view>
    <loading-spinner :loading="loading" />
    <h3 class="menu-error" v-if="error">Error loading menu feed</h3>
    <widget-styles>
      .posabit-widget .PaB-loading-spinner .PaB-spinner {
        border-color: {{ widgetOptions.style.color_primary }};
      }
    </widget-styles>
    <widget-styles v-if="!loading && loaded">
      .posabit-widget {
        font-family: {{ widgetOptions.style.body_font }};
        color: {{ widgetOptions.style.body_font_color }};
      }

      .posabit-widget .PaB-category-info-link,
      .posabit-widget a,
      .posabit-widget .PaB-link {
        color: {{ widgetOptions.style.color_primary }};
      }

      .posabit-widget .PaB-category-info-link:hover,
      .posabit-widget .PaB-category-info-link:focus,
      .posabit-widget a:hover,
      .posabit-widget a:focus,
      .posabit-widget .PaB-link:hover {
        color: {{ widgetOptions.style.color_primary_hover }};
      }

      .posabit-widget h1,
      .posabit-widget h2,
      .posabit-widget h3,
      .posabit-widget h4,
      .posabit-widget h5,
      .posabit-widget h6 {
        color: {{ widgetOptions.style.heading_font_color }};
        font-family: {{ widgetOptions.style.heading_font }};
      }

      .posabit-widget .PaB-chip {
        background-color: {{ widgetOptions.style.color_primary }} !important;
      }

      .posabit-widget .PaB-chip:hover,
      .posabit-widget .PaB-chip:focus {
        background-color: {{ widgetOptions.style.color_primary_hover }} !important;
      }

      .posabit-widget .PaB-button--primary {
        background-color: {{ widgetOptions.style.color_primary }} !important;
        border-color: {{ widgetOptions.style.color_primary }} !important;
      }

      .posabit-widget .PaB-button--primary:hover,
      .posabit-widget .PaB-button--primary:focus {
        background-color: {{ widgetOptions.style.color_primary_hover }} !important;
        border-color: {{ widgetOptions.style.color_primary_hover }} !important;
      }

      .posabit-widget .PaB-button--secondary {
        color: {{ widgetOptions.style.color_primary }} !important;
        border-color: {{ widgetOptions.style.color_primary }} !important;
      }

      .posabit-widget .PaB-button--secondary:hover,
      .posabit-widget .PaB-button--secondary:focus {
        color: {{ widgetOptions.style.color_primary_hover }} !important;
        border-color: {{ widgetOptions.style.color_primary_hover }} !important;
      }
    </widget-styles>
    <widget-styles v-if="widgetOptions.style.theme === 'dark' && !loading && loaded">
      /* POSaBIT Dark Theme */
      .posabit-widget,
      .posabit-widget .PaB-product-card,
      .posabit-widget .PaB-cart-item,
      .posabit-widget .PaB-modal,
      .posabit-widget .PaB-dropdown-content,
      .posabit-widget .is-open>.PaB-button,
      .posabit-widget .is-open .PaB-dropdown-toggle::after,
      .posabit-widget .PaB-accordion {
        background-color: {{ widgetOptions.style.color_background || '#000' }} !important;
      }

      .posabit-widget .PaB-button--default,
      .posabit-widget .PaB-button--plain,
      .posabit-widget .PaB-search-input-field input {
        background-color: {{ widgetOptions.style.color_background || '#000' }} !important;
        color: inherit;
      }

      .posabit-widget .PaB-button--default:hover,
      .posabit-widget .PaB-button--default:focus {
        background-color: {{ widgetOptions.style.color_background || '#000' }} !important;
        color: inherit;
      }

      .posabit-widget .PaB-modal-container {
        border: 1px solid rgba(127, 127, 127, 0.2);
      }
    </widget-styles>
    <v-idle v-if="isKiosk()" @idle="onidle" :duration="1200" />
  </div>
</template>

<style lang="scss" scoped>
.posabit-widget {
  position: relative;
}
</style>

<style lang="scss">
body {
  // Global styles
  .posabit-widget * {
    z-index: auto;
    box-sizing: border-box;
  }

  .posabit-widget {
    font-size: 16px;

    a svg,
    p svg {
      vertical-align: top;
    }

    a {
      text-decoration: none !important;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 0 0 1em;
    }
    button {
      cursor: pointer;
      margin: 0;
    }

    table {
      border-collapse: collapse;
      width: 100%;
    }

    thead {
      border-bottom: 1px solid rgba(#7f7f7f, 0.5);
    }

    tfoot {
      border-top: 1px solid rgba(#7f7f7f, 0.5);
    }

    input {
      margin: 0;
    }

    td,
    th {
      border: 0;
      padding: 5px;
    }

    th {
      text-align: left;
    }

    ul,
    ol {
      margin: 0;
      padding: 0;

      li {
        margin: 0;
        padding: 0;
      }
    }
  }
}
</style>

<script>
import AppHeader from '@/components/AppHeader'
import LoadingSpinner from '@/components/LoadingSpinner'
import WidgetStyles from '@/components/WidgetStyles'

export default {
  name: 'App',
  components: {
    AppHeader,
    LoadingSpinner,
    WidgetStyles
  },
  computed: {
    loading () {
      return this.$store.state.products.loading
    },
    loaded () {
      return this.$store.state.products.loaded
    },
    error () {
      return this.$store.state.products.error
    }
  },
  methods: {
    isKiosk () {
      return !!this.widgetOptions.config.kiosk_mode
    },
    onidle () {
      this.$store.dispatch('cart/resetCart')
      this.$router.push('/')
    }
  },
  watch: {
    loaded (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.eventTracking.dispatchCustomEvent('posabit.loaded')
      }
    }
  }
}
</script>
